import { Observable } from 'rxjs/Observable';
import { delay, switchMap } from 'rxjs/operators';

export function loadWithRetries<T>(load: () => Observable<T>): Observable<T> {
  const backoffMax = 8;
  const maxRetries = 5;

  let backoff = 1;
  let retries = 1;

  function retry(err): Observable<T> {
    if (retries >= maxRetries) return Observable.throw(err);
    retries++;
    backoff *= 2;
    backoff = Math.min(backoff, backoffMax);
    return Observable.of(null)
      .pipe(delay(backoff * 1000))
      .pipe(switchMap(() => load()))
      .catch(error => retry(error));
  }

  return load().catch(err => retry(err));
}



// WEBPACK FOOTER //
// ./src/app/core/utils.ts